import { FieldType } from '@/components/Form';
import { DatabaseField } from '@/modules/corporate/modules/database/fields/types';

import SelectFieldEditorConfig from './Editor/config';
import Cell from './Cell';
import { SelectFieldStaticConfig } from './config';
import EditableCell from './EditableCell';
import FilterInput from './FilterInput';
import SelectOperators from './operators';
import {
  adaptFormData,
  adaptFormField,
  adaptSelectField,
  isFormDataValid,
  parseFormData,
} from './utils';

const SelectField: DatabaseField = {
  ...SelectFieldStaticConfig,
  Table: {
    Cell,
    FilterInput,
    EditableCell,
    operators: SelectOperators,
  },
  Viewer: {
    adaptFormData,
    adaptFormField,
    isFormDataValid,
    parseFormData,
    fieldType: FieldType.Picklist,
  },
  Editor: SelectFieldEditorConfig,
  adaptField: adaptSelectField,
};

export default SelectField;
